//
//
//
//
//
//
//
//
//
//
//
//
//

import Add from "@/components/RegionAccount/Add";
export default {
  name: "AddCity",
  components: { Add },
  data() {
    return {
      accountType: "city",
    };
  },
};
